import * as Constants from './constants'

export const mucHopDongListRequest = function mucHopDongListRequest(formData) {
  return {
    type: Constants.MUC_HOPDONG_LIST_REQUESTING,
    payload: formData
  }
}

export const mucHopDongListSuccess = function mucHopDongListSuccess(data) {
  return {
    type: Constants.MUC_HOPDONG_LIST_SUCCESS,
    data
  }
}

export const mucHopDongListError = function mucHopDongListError(error) {
  return {
    type: Constants.MUC_HOPDONG_LIST_ERROR,
    error
  }
}

export const mucHopDongDetailRequest = function mucHopDongDetailRequest(formData) {
  return {
    type: Constants.MUC_HOPDONG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const mucHopDongDetailSuccess = function mucHopDongDetailSuccess(data) {
  return {
    type: Constants.MUC_HOPDONG_DETAIL_SUCCESS,
    data
  }
}

export const mucHopDongDetailError = function mucHopDongDetailError(error) {
  return {
    type: Constants.MUC_HOPDONG_DETAIL_ERROR,
    error
  }
}

export const mucHopDongUpdateRequest = (formData, callback) => {
  return {
    type: Constants.MUC_HOPDONG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const mucHopDongUpdateSuccess = function mucHopDongUpdateSuccess(response) {
  return {
    type: Constants.MUC_HOPDONG_UPDATE_SUCCESS,
    payload: response
  }
}

export const mucHopDongUpdateError = function mucHopDongUpdateError(error) {
  return {
    type: Constants.MUC_HOPDONG_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/MucHopDong/actions.js